import styled, { css } from "styled-components/native";
import { TextInput } from "react-native-paper";
import { highlightColor, light_black, mid_blue, salmon } from "../../StyleHelpers";
import { Props, StyledViewProps } from "./models";

export const StyledInput = styled(TextInput)<Props>`
	position: relative;
	background-color: ${light_black};
	color: ${mid_blue};
	width: 100%;
	height: ${(props) => (props.height ? `${props.height}px` : "80px")};
	padding-left: 10px;
	flex-grow: 1;
	cursor: pointer;
`;

export const StyledTextError = styled.Text`
	margin-left: 30px;
	font-size: 18px;
	color: ${salmon};
`;

export const StyledView = styled.View<StyledViewProps>`
	position: relative;
	flex-grow: 0;
	flex-shrink: 1;
	flex-basis: 100%;
	height: 100%;
	cursor: pointer;
	z-index: 999;

	${(props) =>
		props.addLeftSpacing &&
		css`
			margin-left: 20px;
		`}
	${(props) =>
		props.addRightSpacing &&
		css`
			margin-right: 20px;
		`}
`;

export const StyledDropDownContainer = styled.View<any>`
	position: absolute;
	margin-top: ${(props) => (props.isNarrow ? `60px` : "80px")};
	width: 100%;
	height: ${(props) => (props.isNarrow ? `150px` : "260px")};
	border: 2px white;
	border-bottom-left-radius: 16px;
	border-bottom-right-radius: 16px;
	background-color: rgb(20, 20, 20);
	overflow-y: scroll;
	z-index: 1000;
`;

export const StyledListItemText = styled.View`
	width: 420px;
`;

export const StyledListItem = styled.View<Props>`
	z-index: 1000;
	width: 100%;
	height: ${(props) => (props.isNarrow ? `50px` : "65px")};
	padding: ${(props) => (props.isNarrow ? `10px 22px` : "22px 22px")};

	&:hover {
		background-color: ${highlightColor};
	}
`;

export const StyledRightIcon = styled.View<any>`
	position: absolute;
	right: 20px;
	top: ${(props) => (props.isReduceTop ? `26px` : "35px")};
`;

export const fontConfig = {
	web: {
		light: {
			fontWeight: 300,
		},
		regular: {
			fontWeight: 400,
		},
		medium: {
			fontWeight: 500,
		},
		bold: {
			fontWeight: 700,
		},
	},
	android: {
		light: {
			fontWeight: 300,
		},
		regular: {
			fontWeight: 400,
		},
		medium: {
			fontWeight: 500,
		},
		bold: {
			fontWeight: 700,
		},
	},
};
